<nz-form-item>
  <nz-form-control [nzValidateStatus]="onValidation ? 'validating' : errorType" [nzErrorTip]="errorMessage">
    <textarea [rows]="field?.customAttributes?.rowNumber ?? rows" nz-input #inputElement [id]="code" [(ngModel)]="value"
      [readOnly]="disabled" (change)="inputChanged()" (keyup)="inputTyped()" placeholder="{{title}}"
      [attr.maxlength]="maxLength" [disabled]="disabled"></textarea>
  </nz-form-control>
</nz-form-item>